// extracted by mini-css-extract-plugin
export default {"animation_text":"AnimatingScores_animation_text__VHZEi"};